﻿import controller from "../../../../Resources/Scripts/_Shared/Controller";
import { createConfirm } from "../../../../resources/scripts/_shared/confirm";
import {
    vehicles,
    users,
    permits,
    waitinglist,
} from "../../_Shared/Scripts/Endpoints";
import {
    apiPromise,
    htmlPromise,
} from "../../../../Resources/Scripts/_Shared/fetch";
import moment from "moment";
import { parseDate } from "../../../../Resources/Scripts/_Shared/parseDate";

export function myAimoParkConfirm(context) {
    const selectedLang = document.querySelector("html").getAttribute("lang");
    let confirmLinks = Array.prototype.slice.call(
        context.querySelectorAll("[data-confirm]")
    );
    const appConfig = controller.getConfig(context);
    let error = false;

    const settings = {
        close: context.dataset.confirmCloseText,
        cancel: context.dataset.confirmCancelText,
        confirm: context.dataset.confirmConfirmText,
    };

    const errorSettings = {
        close: context.dataset.confirmCloseText,
        cancel: null,
        confirm: context.dataset.confirmOkText,
    };

    const handleError = (errorMessage, errorHeading) => {
        createConfirm(
            errorHeading ?? context.dataset.confirmErrorHeading,
            errorMessage.includes("</strong>")
                ? errorMessage.split("</strong>")[1]
                : errorMessage,
            errorSettings,
            () => {
                return;
            }
        );
    };

    const handleVehicleInDom = (
        elementsToRemoveFromDom,
        currentElementToRemove,
        removeVehicleInDom
    ) => {
        currentElementToRemove.removeAttribute("aria-busy");
        if (removeVehicleInDom) {
            const row = currentElementToRemove.closest(".gridrow");
            row.classList.add("deleted");
            row.nextElementSibling.remove();
            setTimeout(() => {
                for (var i = 0; i < elementsToRemoveFromDom.length; i++) {
                    const elementToRemove = elementsToRemoveFromDom[i];
                    elementToRemove.parentNode.removeChild(elementToRemove);
                }
            }, 300);
        }
    };

    function init() {
        if (
            confirmLinks.length === 0 ||
            context.classList.contains("confirm-active")
        )
            return;
        context.classList.add("confirm-active");
        context.addEventListener("click", async (event) => {
            //})
            //confirmLinks.forEach(link => {
            //link.addEventListener('click', async (event) => {
            let message =
                event.target.dataset?.confirmMessageText ??
                context.dataset?.confirmMessageText;
            if (
                event.target.classList.contains("remove") ||
                event.target.classList.contains("download__button") ||
                event.target.classList.contains("terminate") ||
                ((event.target.classList.contains(
                    "facilitypage__cta--longterm"
                ) ||
                    event.target.dataset?.ltpBooking) &&
                    message) ||
                event.target.classList.contains("removeWaitingList")  ||
                event.target.classList.contains("removeWaitingListApproval")
            ) {
                event.preventDefault();
                const confirmType = event.target.dataset.confirm;
                const confirmId = event.target.dataset.id;
                let heading =
                    event.target.dataset.confirmHeadingText ??
                    context.dataset.confirmHeadingText;
                settings.dataButton =
                    confirmType === "terminate"
                        ? "confirm-terminate-salesorder"
                        : confirmType === "preliminaryorder"
                        ? "confirm-decline-preliminaryorder"
                        : confirmType === "invoice"
                        ? "confirm-download-invoice"
                        : "confirm-remove-" + confirmType;
                let onConfirmFunction;
                let notOnActivePermit = false;

                if (confirmType === "facility") {
                    const origin = window.location.origin;
                    const path = event.target.getAttribute("href");
                    settings.checkbox = true;
                    settings.dataButton = "continue-to-form";
                    settings.label = context.dataset.confirmLabelText;
                    onConfirmFunction = () =>
                        (window.location.href =
                            (path[0] === "/" ? origin : "") + path);
                }

                if (confirmType === "vehicle") {
                    const elementsToRemoveFromDom = Array.prototype.slice.call(
                        context.querySelectorAll(
                            `div[data-vehicle-id="${confirmId}"]`
                        )
                    );

                    const plateText =
                        event.target.closest(".gridrow").nextElementSibling
                            .dataset.vehiclePlateText;
                    const uid =
                        event.target.closest(".gridrow").nextElementSibling
                            .dataset.vehicleUid;
                    const currentElement = context.querySelector(
                        `div.edit[data-vehicle-id="${confirmId}"]`
                    );

                    currentElement.setAttribute("aria-busy", "true");

                    const checkPermitsResponse =
                        await vehicles.checkPermitForDeleteVehicle(
                            { id: confirmId, plateText, uid },
                            false
                        );

                    if (checkPermitsResponse.status === 200)
                        notOnActivePermit =
                            !checkPermitsResponse.body.data.existsInPermit;
                    else handleError();

                    handleVehicleInDom(
                        elementsToRemoveFromDom,
                        currentElement,
                        false
                    );

                    onConfirmFunction = () => {
                        currentElement.setAttribute("aria-busy", "true");
                        return new Promise(async (resolve) => {
                            const removeResponse = await vehicles.deleteVehicle(
                                { id: confirmId, plateText, uid },
                                selectedLang
                            );
                            if (removeResponse.status === 200) {
                                handleVehicleInDom(
                                    elementsToRemoveFromDom,
                                    currentElement,
                                    true
                                );
                            } else {
                                handleVehicleInDom(
                                    elementsToRemoveFromDom,
                                    currentElement,
                                    false
                                );
                                handleError(removeResponse.errorMessage);
                                resolve(false);
                                return;
                            }
                            if (
                                context.querySelectorAll("[data-confirm]")
                                    .length === 0
                            )
                                context.innerHTML = "";

                            resolve(true);
                        });
                    };
                } else if (confirmType === "admin") {
                    onConfirmFunction = () => {
                        return new Promise(async (resolve) => {
                            const removeAdministratorResponse =
                                await users.demoteAdmin(
                                    { uid: confirmId },
                                    false,
                                    selectedLang
                                );

                            if (removeAdministratorResponse.status !== 200) {
                                resolve(false);
                                handleError(
                                    removeAdministratorResponse.errorMessage
                                );
                                return;
                            }
                            var elementsToRemoveFromDom =
                                Array.prototype.slice.call(
                                    context.querySelectorAll(
                                        `[data-user-id="${confirmId}"]`
                                    )
                                );
                            for (
                                var i = 0;
                                i < elementsToRemoveFromDom.length;
                                i++
                            ) {
                                const currentElementToRemove =
                                    elementsToRemoveFromDom[i];
                                currentElementToRemove.parentNode.removeChild(
                                    currentElementToRemove
                                );
                            }

                            if (
                                context.querySelectorAll("[data-confirm]")
                                    .length === 0
                            )
                                context.innerHTML = "";

                            resolve(true);
                        });
                    };
                } else if (confirmType === "customer") {
                    onConfirmFunction = () => {
                        return new Promise(async (resolve) => {
                            const removeCustomerResponse =
                                await users.deleteCustomer(
                                    { Contact_Number: confirmId },
                                    false,
                                    selectedLang
                                );
                            if (removeCustomerResponse.status !== 200) {
                                resolve(false);
                                handleError(context.dataset.confirmErrorText);
                                return;
                            }

                            var elementsToRemoveFromDom =
                                Array.prototype.slice.call(
                                    context.querySelectorAll(
                                        `[data-user-id="${confirmId}"]`
                                    )
                                );
                            for (
                                var i = 0;
                                i < elementsToRemoveFromDom.length;
                                i++
                            ) {
                                const currentElementToRemove =
                                    elementsToRemoveFromDom[i];
                                currentElementToRemove.parentNode.removeChild(
                                    currentElementToRemove
                                );
                            }

                            if (
                                context.querySelectorAll("[data-confirm]")
                                    .length === 0
                            )
                                context.innerHTML = "";

                            resolve(true);
                            location.reload();
                        });
                    };
                } else if (confirmType === "preliminaryorder") {
                    onConfirmFunction = () => {
                        return new Promise(async (resolve) => {
                            const currentElement = context.querySelector(
                                `[data-id="${confirmId}"]`
                            );

                            const response =
                                await permits.declinePreliminaryOrder(
                                    { orderId: confirmId },
                                    selectedLang
                                );

                            if (response.status !== 200) {
                                resolve(false);
                                handleError(context.dataset.confirmErrorText);
                                return;
                            }

                            setTimeout(() => {
                                const myAimoParkStartPageBlock =
                                    currentElement.closest(
                                        ".myaimoparkstartpage__block"
                                    );
                                const preliminaryOrderList =
                                    currentElement.closest(
                                        ".myaimoparkpreliminaryorder__list"
                                    );
                                const entryLink =
                                    preliminaryOrderList.nextElementSibling.querySelector(
                                        "A"
                                    );
                                let counter = entryLink
                                    ? +entryLink.innerText.match(/\d/g)[0]
                                    : null;

                                if (
                                    preliminaryOrderList.querySelectorAll("LI")
                                        .length === 1 &&
                                    myAimoParkStartPageBlock
                                )
                                    myAimoParkStartPageBlock.remove();
                                else if (
                                    preliminaryOrderList.querySelectorAll("LI")
                                        .length === 1
                                )
                                    preliminaryOrderList.innerHTML = "";
                                else
                                    currentElement.parentNode.parentNode.remove();
                                if (counter)
                                    entryLink.innerText =
                                        entryLink.innerText.replace(
                                            /\(.*?\)/,
                                            `(${--counter})`
                                        );
                            }, 500);
                            resolve(true);
                            location.reload();
                        });
                    };
                } else if (confirmType === "invoice") {
                    return new Promise(async (resolve) => {
                        const checkIfFileExists = await apiPromise(
                            `/myaimoparkinvoicespage/CheckIfDocumentExist`,
                            { documentNumber: confirmId },
                            selectedLang,
                            "GET"
                        ).catch((err) => err);
                        if (checkIfFileExists.status !== 200) {
                            resolve(false);
                            handleError(checkIfFileExists.body.ErrorMessage);
                            return;
                        }
                        const url = `${
                            location.protocol +
                            "//" +
                            location.host +
                            location.pathname
                        }downloaddocument?documentNumber=${confirmId}`;
                        const pdfLink = document.createElement("a");
                        pdfLink.style.display = "none";
                        pdfLink.href = url;
                        pdfLink.setAttribute("download", "");
                        //This allows download in desktop safari if pop up blocking is enabled
                        if (typeof pdfLink.download === "undefined")
                            pdfLink.setAttribute("target", "_blank");
                        document.body.appendChild(pdfLink);
                        pdfLink.click();
                        pdfLink.remove();
                        resolve(true);
                    });
                } else if (confirmType === "terminate") {
                    settings.zIndex = 3101;
                    errorSettings.zIndex = 3101;
                    settings.label = appConfig.localization.label;
                    settings.initialOption = appConfig.localization.noreason;

                    const salesOrderId = confirmId;
                    const orderLineId =
                        event.target.dataset.orderlineId.substring(
                            0,
                            event.target.dataset.orderlineId.lastIndexOf("-")
                        );
                    const terminateDateResponse =
                        salesOrderId && orderLineId
                            ? await apiPromise(
                                  `/myaimopark/GetOrderLineTerminationDate`,
                                  { salesOrderId, orderLineId }
                              ).catch((err) => err)
                            : null;
                    const terminateDate =
                        terminateDateResponse &&
                        terminateDateResponse.body.TerminationDate
                            ? parseDate(
                                  terminateDateResponse.body.TerminationDate,
                                  appConfig.localization.locale,
                                  "L"
                              )
                            : null;
                    const orderEndDate = appConfig.endDate
                        ? parseDate(
                              appConfig.endDate,
                              appConfig.localization.locale,
                              "L"
                          )
                        : null;

                    if (
                        terminateDate &&
                        orderEndDate &&
                        (terminateDate === orderEndDate ||
                            moment(orderEndDate).isBefore(terminateDate, "day"))
                    ) {
                        error = true;
                        handleError(
                            `${appConfig.localization.existingdate} ${orderEndDate}`,
                            appConfig.localization.sorry
                        );
                    } else if (terminateDate) {
                        message = `${appConfig.localization.parkingends} ${terminateDate}`;
                        settings.options = appConfig.terminateReasons;
                    } else {
                        error = true;
                        handleError(
                            appConfig.localization.notpossible,
                            appConfig.localization.sorry
                        );
                    }
                    onConfirmFunction = () => {
                        return new Promise(async (resolve) => {
                            const confirmSelect = document.querySelector(
                                ".myaimopark-confirm__select-wrapper select"
                            );
                            const body = {
                                reason: confirmSelect.value,
                                terminationDate:
                                    terminateDateResponse.body.TerminationDate,
                                orderTerminationLetterConf: {
                                    distributionMethod: "EMAIL",
                                },
                            };
                            const terminatePermitResponse = await htmlPromise(
                                `/myaimopark/TerminateOrderLine`,
                                { salesOrderId, orderLineId, body },
                                selectedLang,
                                "POST"
                            ).catch((err) => err);
                            const terminatePermitResponseBody =
                                terminatePermitResponse?.body
                                    ? JSON.parse(terminatePermitResponse.body)
                                    : null;
                            if (
                                terminatePermitResponseBody &&
                                terminatePermitResponseBody.StatusCode !== 200
                            ) {
                                resolve(false);
                                handleError(
                                    terminatePermitResponseBody.ErrorMessage
                                );
                                return;
                            }
                            resolve(true);
                            createConfirm(
                                `${appConfig.localization.terminated}`,
                                `${appConfig.localization.parkingends} ${terminateDate}`,
                                {
                                    close: context.dataset.confirmCloseText,
                                    confirm: context.dataset.confirmOkText,
                                    zIndex: settings.zIndex + 1,
                                },
                                () => location.reload()
                            );
                        });
                    };
                } else if (confirmType === "removeWaitingList") {
                    const waitingListItemId = event.target.dataset.id;
                    message = `${appConfig.localization.warning}`;

                    settings.options = appConfig.terminateReasons;
                    settings.zIndex = 3102;
                    settings.label = appConfig.localization.label;
                    settings.initialOption = appConfig.localization.noreason;
                    errorSettings.zIndex = 3102;

                    onConfirmFunction = () => {
                        return new Promise(async (resolve) => {
                            const currentElement = context.querySelector(
                                `[data-id="${waitingListItemId}"]`
                            );

                            const confirmSelect = document.querySelector(
                                ".myaimopark-confirm__select-wrapper select"
                            );
                            const response =
                                await waitinglist.removeFromWaitingList({
                                    waitingListItemId,
                                    reason: confirmSelect.value,
                                });
                            if (response.status !== 204) {
                                resolve(false);
                                handleError(context.dataset.confirmErrorText);
                                return;
                            }
                            resolve(true);
                            const terminatePermitResponseBody = null;
                            // createConfirm(
                            //     `${appConfig.localization.terminated}`,
                            //     {
                            //         close: context.dataset.confirmCloseText,
                            //         confirm: context.dataset.confirmOkText,
                            //         zIndex: 4500 + 1,
                            //     },
                            //     () => location.reload()
                            // );
                            location.reload();
                        });
                    };
                } else if (confirmType === "removeWaitingListApproval") {
                    const requestId = event.target.dataset.id;
                    message = `${appConfig.localization.warning}`;

                    settings.options = appConfig.terminateReasons;
                    settings.zIndex = 3103;
                    settings.label = appConfig.localization.label;
                    settings.initialOption = appConfig.localization.noreason;
                    errorSettings.zIndex = 3103;

                    onConfirmFunction = () => {
                        return new Promise(async (resolve) => {
                            const currentElement = context.querySelector(
                                `[data-id="${requestId}"]`
                            );

                            const confirmSelect = document.querySelector(
                                ".myaimopark-confirm__select-wrapper select"
                            );
                            const response =
                                await waitinglist.removeFromWaitingListApproval({
                                    requestId,
                                    reason: confirmSelect.value,
                                });
                            if (response.status !== 200) {
                                resolve(false);
                                handleError(context.dataset.confirmErrorText);
                                return;
                            }
                            resolve(true);
                            location.reload();
                        });
                    };
                }

                if (notOnActivePermit)
                    createConfirm(heading, " ", settings, onConfirmFunction);
                else if (!error) {
                    createConfirm(
                        heading,
                        message,
                        settings,
                        onConfirmFunction
                    );
                }
                if (confirmType === "facility" && settings.checkbox) {
                    const confirmButton = document.querySelector(
                        ".myaimopark-confirm__box__confirm"
                    );
                    const checkbox = document.querySelector(
                        ".myaimopark-confirm__checkbox-original"
                    );
                    const activateConfirmButton = () => {
                        if (checkbox.checked)
                            confirmButton.removeAttribute("disabled");
                        else confirmButton.setAttribute("disabled", "true");
                        checkbox.setAttribute("aria-checked", "true");
                        checkbox.setAttribute("disabled", "true");
                        checkbox.removeEventListener(
                            "change",
                            activateConfirmButton
                        );
                    };
                    checkbox.addEventListener("change", activateConfirmButton);
                }
                //});
            }
        });
    }

    return {
        init,
    };
}

controller.add("myaimopark-confirm", myAimoParkConfirm);
